import { Injectable } from '@angular/core';
import { fromLegacyPromise, getAngularJSService } from '../ng-upgrade.utils';
import {
  Entity,
  Pagination,
  VehicleDetails,
  VehicleHistoricFilter,
  VehicleHistoricListResponse,
  VehicleHistoricListResult,
} from '@core/models';

interface LegacyHttpResponse<T> {
  data: T;
}

interface LegacyVehicleFactory {
  getVehicleHistoricList(
    pagination: Pagination,
    filter: VehicleHistoricFilter
  ): Promise<LegacyHttpResponse<VehicleHistoricListResult>>;
  getEntities(): Promise<LegacyHttpResponse<Entity[]>>;
}

interface LegacyVehicleChangesHistoryFactory {
  getVehicleById(id: number): Promise<LegacyHttpResponse<VehicleDetails>>;
}

@Injectable({ providedIn: 'root' })
export class VehicleChangesHistoryService {
  private vehicleFactory: LegacyVehicleFactory | null = null;
  private changesHistoryFactory: LegacyVehicleChangesHistoryFactory | null = null;

  private get vehicle(): LegacyVehicleFactory {
    if (this.vehicleFactory) {
      return this.vehicleFactory;
    }
    const factory = getAngularJSService<LegacyVehicleFactory>('vehicleFactory');
    if (!factory) {
      throw new Error('vehicleFactory não disponível.');
    }
    this.vehicleFactory = factory;
    return this.vehicleFactory;
  }

  private get changesHistory(): LegacyVehicleChangesHistoryFactory {
    if (this.changesHistoryFactory) {
      return this.changesHistoryFactory;
    }
    const factory = getAngularJSService<LegacyVehicleChangesHistoryFactory>(
      'vehicleChangesHistoryFactory'
    );
    if (!factory) {
      throw new Error('vehicleChangesHistoryFactory não disponível.');
    }
    this.changesHistoryFactory = factory;
    return this.changesHistoryFactory;
  }

  async getVehicleHistoricList(
    pagination: Pagination,
    filter: VehicleHistoricFilter
  ): Promise<VehicleHistoricListResponse> {
    // WRAPPER — reescrever com HttpClient quando vehicleFactory for removida
    const response = await fromLegacyPromise(
      this.vehicle.getVehicleHistoricList(pagination, filter)
    );
    return response.data.result ?? { rows: [], count: 0 };
  }

  async getEntities(): Promise<Entity[]> {
    // WRAPPER — reescrever com HttpClient quando vehicleFactory for removida
    const response = await fromLegacyPromise(this.vehicle.getEntities());
    return response.data;
  }

  async getVehicleById(vehicleId: number): Promise<VehicleDetails> {
    // WRAPPER — reescrever com HttpClient quando vehicleChangesHistoryFactory for removida
    const response = await fromLegacyPromise(this.changesHistory.getVehicleById(vehicleId));
    return response.data;
  }
}
